import { Tooltip, tooltipClasses, TooltipProps } from '@mui/material'
import React, { ReactElement } from 'react'
import styled from 'styled-components'

type ComponentWithMessageProps = {
    children: ReactElement
    message: string
    placement?: 'top' | 'bottom' | 'left' | 'right'
    showMessage?: boolean
}

export const ComponentWithMessage: React.FC<ComponentWithMessageProps> = ({
    children,
    message,
    placement = 'bottom',
    showMessage = true,
}) => {
    if (!showMessage) return <span>{children}</span>
    return (
        <CustomWidthTooltip title={message} placement={placement}>
            <span>{children}</span>
        </CustomWidthTooltip>
    )
}

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 500,
        padding: 18,
        opacity: 0.5,
        fontSize: 12,
        fontFamily: 'Roboto',
    },
})
